'use client'

import dynamic from 'next/dynamic'

/**
 * Client-only wrapper so we can use dynamic(..., { ssr: false }) for the memory monitor.
 * Next.js does not allow ssr: false in Server Components (e.g. layout.tsx).
 * Only loads and renders the monitor in development.
 */
const GlobalMemoryMonitor = dynamic(
  () => import('@/app/_components/GlobalMemoryMonitor'),
  { ssr: false }
)

export function GlobalMemoryMonitorWrapper() {
  if (process.env.NODE_ENV !== 'development') {
    return null
  }
  return <GlobalMemoryMonitor />
}
